export default "__VITE_ASSET__DTB_JA7i__"